<div class="flex items-center justify-center bg-gray-50 p-4">
  <mat-card class="w-full max-w-md">
    <mat-card-header>
      <mat-card-title>Set Up Two-Factor Authentication</mat-card-title>
      <mat-card-subtitle>
        Your workspace requires two-factor authentication. Please set up a
        verification method to continue.
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content class="mt-4">
      <mat-tab-group>
        <mat-tab label="Authenticator App">
          <div class="pt-4">
            <pt-totp-enrol (enrolled)="onEnrolled($event)" />
          </div>
        </mat-tab>
        <mat-tab label="Phone / SMS">
          <div class="pt-4">
            <pt-phone-enrol
              [phoneNumber]="userPhone()"
              (enrolled)="onEnrolled($event)"
            />
          </div>
        </mat-tab>
      </mat-tab-group>
    </mat-card-content>
  </mat-card>
</div>
